import { RANGE_SLIDER_THEMES } from '../constants'
import type { RangeSliderTheme } from '../types'

export function getRangeSliderTheme(
  theme: RangeSliderTheme,
): [string, string, string] {
  const { trackBackground, trackForeground } = RANGE_SLIDER_THEMES[theme]
  return [trackBackground, trackForeground, trackBackground]
}
